import { useCallback } from 'react';
import {
  useGetKeyValueSettings,
  useKeyValueSettingsMutation,
  updateCache
} from '~/modules/common/hooks';
import { useMeContext } from '~/modules/me';

export const INSIGHTS_SETTINGS_KEY = 'insights_settings';

export const INSIGHTS_SETTINGS_FIELDS = {
  DISPLAY_UNIT: 'displayUnit',
  PERIOD_SCALE: 'periodScale',
  SELECTED_VIEW: 'selectedView',
  GROUP_BY: 'groupBy',
  SELECTED_PROBLEM: 'selectedProblem'
};

export const useInsightsSettings = () => {
  const {
    featureFlags: { isPsaRmpBenchOverallocationEnabled }
  } = useMeContext();

  const { isLoading, keyValueSettings } = useGetKeyValueSettings(
    INSIGHTS_SETTINGS_KEY,
    !isPsaRmpBenchOverallocationEnabled
  );

  return {
    isLoading,
    insightsSettings: keyValueSettings
  };
};

export const usePutInsightsSettings = () => {
  const {
    featureFlags: { isPsaRmpBenchOverallocationEnabled }
  } = useMeContext();

  const [putKeyValueSettings] = useKeyValueSettingsMutation(
    updateCache(INSIGHTS_SETTINGS_KEY)
  );

  const putInsightsSettings = useCallback(
    settings => {
      putKeyValueSettings({
        variables: {
          input: {
            key: INSIGHTS_SETTINGS_KEY,
            settings
          }
        }
      });
    },
    [putKeyValueSettings]
  );

  return {
    putInsightsSettings: isPsaRmpBenchOverallocationEnabled
      ? putInsightsSettings
      : null
  };
};
